"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalProvidersWrapper = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var constants_1 = require("../common/constants");
var locales_1 = require("../resources/locales");
var react_intl_1 = require("react-intl");
var defineTheme = function (outerTheme) {
    var _a;
    var theme = __assign({}, outerTheme);
    if ((_a = outerTheme.variables) === null || _a === void 0 ? void 0 : _a.palette.approval) {
        return core_1.createMuiTheme(outerTheme);
    }
    theme.variables.palette && (theme.variables.palette.approval = constants_1.defaultTheme);
    return core_1.createMuiTheme(theme);
};
exports.ApprovalProvidersWrapper = function (props) {
    var _a = props.locale, locale = _a === void 0 ? constants_1.defaultLocale : _a, _b = props.locales, locales = _b === void 0 ? {} : _b, children = props.children;
    var messages = __assign(__assign({}, locales_1.translations[locale]), locales[locale]);
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: defineTheme },
        react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages }, children)));
};
